import { Component, Event, EventEmitter, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'biel-terms-modal',
  styleUrl: 'biel-terms-modal.css',
  shadow: true,
})
export class BielTermsModal {
  @Prop() termsTitle: string = 'Chatbot Terms & Conditions';
  @Prop() termsDescription: string =
    "Please review our <a href='https://biel.ai/terms' target='_blank' rel='noopener'>Terms & Conditions</a> before proceeding.";
  @Prop() termsCheckboxText: string = 'I have read and agree to the Terms & Conditions.';

  @Event() termsAccepted: EventEmitter<void>;
  @Event() termsDeclined: EventEmitter<boolean>;

  @State() isChecked: boolean = false;

  handleCheckboxChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    this.isChecked = checkbox.checked;
  }

  handleAccept() {
    this.termsAccepted.emit();
  }

  handleDecline() {
    this.termsDeclined.emit(true);
  }

  render() {
    return (
      <div class="biel-terms-modal">
        <div class="biel-terms-modal-content">
          <button class="close-btn" onClick={() => this.handleDecline()} aria-label="Close">
            ×
          </button>
          <h2 class="biel-terms-modal-title">{this.termsTitle}</h2>
          <p class="biel-terms-modal-text" innerHTML={this.termsDescription}></p>
          <div class="checkbox-container">
            <input
              type="checkbox"
              id="accept-terms"
              onInput={(event) => this.handleCheckboxChange(event)}
            />
            <label htmlFor="accept-terms">{this.termsCheckboxText}</label>
          </div>
          <div class="button-container">
            <button class="btn decline-btn" onClick={() => this.handleDecline()}>
              Decline
            </button>
            <button
              class="btn accept-btn"
              onClick={() => this.handleAccept()}
              disabled={!this.isChecked}
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    );
  }
}
